import script from "./ViewSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSetup.vue?vue&type=script&setup=true&lang=js"

import "./ViewSetup.vue?vue&type=style&index=0&id=8e2b8bfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e2b8bfe"]])

export default __exports__